"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfVariantsQueryValidationError = instanceOfVariantsQueryValidationError;
exports.VariantsQueryValidationErrorFromJSON = VariantsQueryValidationErrorFromJSON;
exports.VariantsQueryValidationErrorFromJSONTyped = VariantsQueryValidationErrorFromJSONTyped;
exports.VariantsQueryValidationErrorToJSON = VariantsQueryValidationErrorToJSON;
exports.VariantsQueryValidationErrorToJSONTyped = VariantsQueryValidationErrorToJSONTyped;
/**
 * Check if a given object implements the VariantsQueryValidationError interface.
 */
function instanceOfVariantsQueryValidationError(value) {
    if (!('q' in value) || value['q'] === undefined)
        return false;
    return true;
}
function VariantsQueryValidationErrorFromJSON(json) {
    return VariantsQueryValidationErrorFromJSONTyped(json, false);
}
function VariantsQueryValidationErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'q': json['q'],
    };
}
function VariantsQueryValidationErrorToJSON(json) {
    return VariantsQueryValidationErrorToJSONTyped(json, false);
}
function VariantsQueryValidationErrorToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'q': value['q'],
    };
}
//# sourceMappingURL=variantsQueryValidationError.js.map